import "glightbox/dist/css/glightbox.min.css";

import GLightbox from "glightbox";

const lightbox = GLightbox({
	selector: "body.page-template-template-park-map .glightbox--map",
});

const zoomBtn = document.querySelector(
	"body.page-template-template-park-map #btn--zoom"
);

if (zoomBtn) {
	zoomBtn.addEventListener("click", () => {
		lightbox.open();
	});
}
